import { Checkbox, FormControlLabel } from '@mui/material'
import { ReactComponent as CheckBorder } from '../../images/checkBorder.svg'
import { ReactComponent as CheckedIcon } from '../../images/checkedIcon.svg'

const OfoqCheckbox = ({
  name, defaultOption, refState, customStyle, disabled,
}) => {
  const changeStatusHandler = () => {
    refState(!defaultOption)
  }

  return (
    <FormControlLabel
      sx={[styles.root, customStyle]}
      control={(
        <Checkbox
          checked={defaultOption}
          onChange={changeStatusHandler}
          disabled={disabled}
          icon={<CheckBorder />}
          id={name}
          name={name}
          checkedIcon={(
            <CheckedIcon
              style={styles.checkedIcon}
            />
)}
        />
)}
      label={name}
    />
  )
}

const styles = {
  root: {
    '& .MuiFormControlLabel-label': {
      fontSize: '14px',
    },
    '& .MuiCheckbox-colorPrimary': {
      color: 'primary.border',
    },
    '& .Mui-checked': {
      color: 'primary.main',
    },

  },
  checkedIcon: {
    width: '20px',
    height: '20px',
  },
}

export default OfoqCheckbox
